export default "__VITE_ASSET__D0TirR1n__"